import { __awaiter, __generator } from "tslib";
import { AccountServer } from '@wix/ambassador-account-server/http';
import { HttpClient } from '@wix/http-client';
import { ACCOUNT_SERVER_PREFIX, USER_ACCOUNTS_BY_EMAIL } from '../constants';
var httpClient = new HttpClient();
var accountService = AccountServer(ACCOUNT_SERVER_PREFIX).AccountService();
export var fetchUserAccountsByEmail = function (email) {
    return httpClient
        .post(USER_ACCOUNTS_BY_EMAIL, { email: email.trim() })
        .then(function (response) { return response.data; });
};
export var fetchUserAccounts = function () {
    return accountService().getMyUserAccounts({ paging: { limit: 50 } });
};
export var getLoggedInAccount = function () { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, httpClient
                .get("/login/api/loggedInAccountId")
                .then(function (response) { return response.data; })
                .catch(function () { return ''; })];
    });
}); };
//# sourceMappingURL=api.js.map